import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  Snackbar,
  Alert,
  Card,
  CardContent,
  Chip,
  IconButton,
  Tooltip,
  TableContainer,
  Autocomplete,
  Checkbox,
} from "@mui/material";
import {
  Science as ScienceIcon,
  Article as ArticleIcon,
  Close as CloseIcon,
  CloudUpload as CloudUploadIcon,
  Delete as DeleteIcon,
  Image as ImageIcon,
  CheckBoxOutlineBlank as CheckBoxOutlineBlankIcon,
  CheckBox as CheckBoxIcon,
} from "@mui/icons-material";
import {
  Stack,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import axios from "axios";
import { decryptText, decryptAppId } from "../../../utils/encryption";
import s3Utils from "../../../utils/s3Utils";
import PageTitle from "../../../components/PageTitle";
import useAssessmentTracking from "../../../hooks/useAssessmentTracking";
import {
  LocationWarningDialog,
  HourlyAttendanceDialog,
} from "../../../components/AssessmentTrackingDialogs";
import commonAPIService  from '../../../services/commonAPIService'

export default function ScopeWitnessCalibration() {
  const location = useLocation();

  const getOrgIdFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedOrgId = searchParams.get("orgId");
    if (encryptedOrgId) {
      try {
        const decryptedOrgId = decryptText(encryptedOrgId);
        console.log("📍 Using decrypted orgId from URL query:", decryptedOrgId);
        return decryptedOrgId;
      } catch (error) {
        return encryptedOrgId;
      }
    }
    return null;
  };

  // Function to get appId from URL query parameters with decryption
  const getAppIdFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedAppId = searchParams.get("appId");
    if (encryptedAppId) {
      try {
        const decryptedAppId = decryptAppId(encryptedAppId);
        return decryptedAppId;
      } catch (error) {
        return encryptedAppId;
      }
    }
    return null;
  };

  // Function to get assessmentId from URL query parameters with decryption
  const getAssessmentIdFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedAssessmentId = searchParams.get("assessmentId");
    if (encryptedAssessmentId) {
      try {
        const decryptedAssessmentId = decryptText(encryptedAssessmentId);
        console.log(
          "📍 Using decrypted assessmentId from URL query:",
          decryptedAssessmentId
        );
        return decryptedAssessmentId;
      } catch (error) {
        return encryptedAssessmentId;
      }
    }
    return null;
  };

  // Function to get assessorId from URL query parameters with decryption
  const getAssessorIdFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedAssessorId = searchParams.get("assessorId");
    if (encryptedAssessorId) {
      try {
        const decryptedAssessorId = decryptText(encryptedAssessorId);
        console.log(
          "📍 Using decrypted assessorId from URL query:",
          decryptedAssessorId
        );
        return decryptedAssessorId;
      } catch (error) {
        return encryptedAssessorId;
      }
    }
    return null;
  };

  // Function to get assessorId from URL query parameters with decryption
  const getLabTypeFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedLabType = searchParams.get("labType");
    if (encryptedLabType) {
      try {
        const decryptedLabType = decryptText(encryptedLabType);
        console.log(
          "📍 Using decrypted labType from URL query:",
          decryptedLabType
        );
        return decryptedLabType;
      } catch (error) {
        return encryptedLabType;
      }
    }
    return null;
  };

  // Function to get type from URL query parameters with decryption
  const getTypeFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedType = searchParams.get("type");
    if (encryptedType) {
      try {
        const decryptedType = decryptText(encryptedType);
        console.log("📍 Using decrypted type from URL query:", decryptedType);
        return decryptedType;
      } catch (error) {
        return encryptedType;
      }
    }
    return null;
  };
  // Function to get Standard from URL query parameters with decryption
  const getStandardFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encryptedStandard = searchParams.get("standard");
    if (encryptedStandard) {
      try {
        const decryptedStandard = decryptText(encryptedStandard);
        console.log(
          "📍 Using decrypted standard from URL query:",
          decryptedStandard
        );
        return decryptedStandard;
      } catch (error) {
        return encryptedStandard;
      }
    }
    return null;
  };

  // Function to get Standard from URL query parameters with decryption
  const getuserTypeFromQuery = () => {
    const searchParams = new URLSearchParams(location.search);
    const encrypteduserType = searchParams.get("userType");
    if (encrypteduserType) {
      try {
        const decrypteduserType = decryptText(encrypteduserType);
        console.log(
          "📍 Using decrypted userType from URL query:",
          decrypteduserType
        );
        return decrypteduserType;
      } catch (error) {
        return encrypteduserType;
      }
    }
    return null;
  };

  const getOrgId = () => {
    const queryOrgId = getOrgIdFromQuery();
    if (queryOrgId) {
      return queryOrgId;
    }
    return null;
  };

  const getAppId = () => {
    const queryAppId = getAppIdFromQuery();
    if (queryAppId) {
      return queryAppId;
    }
    return null;
  };

  const getAssessmentId = () => {
    const queryAssessmentId = getAssessmentIdFromQuery();
    if (queryAssessmentId) {
      return queryAssessmentId;
    }
    return null;
  };

  const getAssessorId = () => {
    const queryAssessorId = getAssessorIdFromQuery();
    if (queryAssessorId) {
      return queryAssessorId;
    }
    return null;
  };

  const getLabType = () => {
    const queryLabType = getLabTypeFromQuery();
    if (queryLabType) {
      return queryLabType;
    }
    return null;
  };

  const getType = () => {
    const queryType = getTypeFromQuery();
    if (queryType) {
      return queryType;
    }
    return null;
  };

  const getStandard = () => {
    const queryStandard = getStandardFromQuery();
    if (queryStandard) {
      return queryStandard;
    }
    return null;
  };

  const getuserType = () => {
    const queryuserType = getuserTypeFromQuery();
    if (queryuserType) {
      return queryuserType;
    }
    return null;
  };

  const [orgId, setOrgId] = useState(getOrgId());
  const [appId, setAppId] = useState(getAppId());
  const [assessmentId, setAssessmentId] = useState(getAssessmentId());
  const [assessorId, setAssessorId] = useState(getAssessorId());
  const [labType, setLabType] = useState(getLabType());
  const [type, setType] = useState(getType());
  const [userType, setUserType] = useState(getuserType());
  const [standard, setStandard] = useState(getStandard());
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Assessment tracking hook for location and hourly attendance
  const {
    locationWarningOpen,
    distanceMessage,
    attendanceCheckDialogOpen,
    attendanceCheckMessage,
    setLocationWarningOpen,
    setAttendanceCheckDialogOpen,
    checkHourlyAttendance,
  } = useAssessmentTracking({
    assessorId,
    appId,
    orgId,
  });
  const [loading, setLoading] = useState(false);
  const [scopeList, setScopeList] = useState([]);
  const [selectedScope, setSelectedScope] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [earlierDate, setEarlierDate] = useState("");
  const [earlierDateNA, setEarlierDateNA] = useState("");
  const [isTestBySamePerson, setIsTestBySamePerson] = useState("");
  const [typeOfWitness, setTypeOfWitness] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [scrutinyRemarks, setScrutinyRemarks] = useState([]);
  const [selectedNCStatements, setSelectedNCStatements] = useState([]);
  const [testingOfRM, setTestingOfRM] = useState("");
  const [loadingRemarks, setLoadingRemarks] = useState(false);
  const [formData, setFormData] = useState({
    sampleId: "",
    earlierTestedBy: "",
    earlierResults: "",
    witnessedResults: "",
    otherPersonName: "",
    referenceMaterial: "",
    specifiedValue: "",
    rmResults: "",
    deviations: "",
    conclusion: "",
    remark: "",
    testConductedBy: "",
    checkPoints: ""
  });

  const handleClose = () => {
    setOpenForm(false);
    window.location.reload();
  };

  // 🔹 LOAD SCOPE DATA
  useEffect(() => {
    loadScopeData();
  }, []);

  // 🔹 FETCH SCRUTINY REMARKS WHEN FORM OPENS
  useEffect(() => {
    if (openForm && scrutinyRemarks.length === 0) {
      fetchScrutinyRemarks();
    }
  }, [openForm]);

  // 🔹 FETCH EXISTING NC STATEMENTS WHEN SCOPE IS SELECTED
  useEffect(() => {
    if (selectedScope?.id && openForm && scrutinyRemarks.length > 0) {
      fetchExistingNCStatements(selectedScope.id);
    } else if (!openForm) {
      setSelectedNCStatements([]);
    }
  }, [selectedScope?.id, openForm, scrutinyRemarks.length]);

  // 🔹 POPULATE FORM FROM SELECTED SCOPE
  useEffect(() => {
    if (selectedScope?.naF3A?.[0]) {
      const data = selectedScope.naF3A[0];
      setFormData({
        sampleId: data.freshSampleId || "",
        earlierTestedBy: data.earlierTestedBy || "",
        earlierResults: data.earlierReportedResults || "",
        witnessedResults: data.resultOfTestWitnessed1 || "",
        otherPersonName: data.testConductedByDifferentPerson || "",
        referenceMaterial: data.refernceMaterial || "",
        specifiedValue: data.specifiedValue || "",
        rmResults: data.resultOfTestWitnessed2 || "",
        deviations: data.deviationObserved || "",
        conclusion: data.conclusion || "",
        remark: data.observation || "",
        testConductedBy: data.testConductedBy || "",
      });
      setEarlierDate(data.earlierTestdate || "");
      setEarlierDateNA(data.earlierTestdate === "NA" ? "NA" : "");
      setIsTestBySamePerson(data.resultOfTestWitnessedSamePerson || "");
      setTypeOfWitness(data.type_witness || "");
      setTestingOfRM(data.testingOfRM || "");
      // Load existing images
      if (data.imgearr && Array.isArray(data.imgearr)) {
        setUploadedFiles(
          data.imgearr.map((img) => ({
            name: img.imgfile,
            url: img.imgfile,
            isExisting: true,
            id: img.id,
          }))
        );
      } else {
        setUploadedFiles([]);
      }
    } else {
      setUploadedFiles([]);
    }
  }, [selectedScope]);

  const loadScopeData = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/Scopedetails?assessorId=${assessorId}&assessmentId=${assessmentId}&appId=${appId}&orgId=${orgId}&Labtypeid=${labType}&docid=400`;
      const res = await axios.get(url);

      if (res.data?.isstatus) {
        const updatedScopeList = (res.data.scope || []).map((scope) => ({
       ...scope,
        checkPoints: scope.naF3A?.[0]?.type_witness || "",
       }));
       setScopeList(updatedScopeList);
        //setScopeList(res.data.scope || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenForm = (scope) => {
    const savedCheckPoints = scope.naF3A?.[0]?.type_witness;
    if (savedCheckPoints) {
      setSelectedScope(scope);
      setOpenForm(true);
    } else {
      showSnackbar("Please enter and save the proposed check points before proceeding.", "error");
    }
  };

  // Function to fetch scrutiny remarks from API
  const fetchScrutinyRemarks = async () => {
    setLoadingRemarks(true);
    try {
      const labTypeString =
        labType === "3"
          ? "Medical"
          : labType === "2"
          ? "Calibration"
          : "Testing";
      const url = `${
        process.env.REACT_APP_DOT_NET_CORE_API_URL
      }/GetClauseNo?standard=${
        standard || "2022"
      }&userType=${userType}&labType=${labTypeString}&appId=${appId}&orgId=${orgId}`;
      const response = await axios.get(url);

      if (response.data?.isstatus) {
        setScrutinyRemarks(response.data.clause || []);
        console.log("NC Statements loaded:", response.data.clause?.length);
      } else {
        showSnackbar("Failed to fetch NC statements", "error");
      }
    } catch (error) {
      console.error("Error fetching scrutiny remarks:", error);
      showSnackbar("Error loading NC statements", "error");
    } finally {
      setLoadingRemarks(false);
    }
  };

  // Function to fetch existing NC statements for selected scope
  const fetchExistingNCStatements = async (scopeId) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}/assessment/nc-clause-statement?assessorId=${assessorId}&assessmentId=${assessmentId}&appId=${appId}&orgId=${orgId}&sourceId=${scopeId}&section=Scope Witness`;
      const response = await axios.get(url);

      if (
        response.data?.success &&
        response.data.data &&
        scrutinyRemarks.length > 0
      ) {
        // Find matching objects from scrutinyRemarks to ensure proper selection in autocomplete
        const savedStatements = response.data.data
          .map((item) => {
            // Find the exact match in scrutinyRemarks
            return scrutinyRemarks.find(
              (remark) =>
                remark.displayName === item.nc_Clause &&
                remark.name === item.nc_statement
            );
          })
          .filter(Boolean); // Remove any undefined matches

        setSelectedNCStatements(savedStatements);
      }
    } catch (error) {
      console.error("Error fetching existing NC statements:", error);
      // Don't show error snackbar as this is a silent load operation
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const handleCheckPointsChange = (index, field, value) => {
  const updatedScopeList = [...scopeList];

  updatedScopeList[index] = {
    ...updatedScopeList[index],
    [field]: value,
  };
  setScopeList(updatedScopeList);
};

const handleSaveCheckPoints = async (scope) => {
  try {
    if (!scope.checkPoints?.trim()) {
      showSnackbar("Please enter Check Points", "error");
      return;
    }
    const payload = {
      scopeId: scope.id,
      checkPoints: scope.checkPoints,
      appId,
      orgId,
      assessmentId,
      assessorId,
    };
    console.log("Save Payload:", payload);
    const response = await commonAPIService.saveCheckPointsCalibrationWitness(payload)
    if (response.success) {
      showSnackbar("Check Points saved successfully", "success");
      await loadScopeData();
    } else {
      showSnackbar(
        response.message || "Failed to save Check Points",
        "error"
      );
    }
  } catch (error) {
    console.error("Error saving Check Points:", error);
    showSnackbar("Error while saving Check Points", "error");
  }
};

  // Handle file upload
  const handleFileUpload = async (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    setUploading(true);
    try {
      const uploadPromises = files.map(async (file) => {
        const uploadResult = await s3Utils.uploadFile(file);
        if (uploadResult.success) {
          return {
            name: uploadResult.fileName,
            url: uploadResult.url,
            isExisting: false,
          };
        }
        return null;
      });

      const uploadedResults = await Promise.all(uploadPromises);
      const successfulUploads = uploadedResults.filter(
        (result) => result !== null
      );

      setUploadedFiles((prev) => [...prev, ...successfulUploads]);
      showSnackbar(
        `${successfulUploads.length} file(s) uploaded successfully!`,
        "success"
      );
    } catch (error) {
      console.error("Error uploading files:", error);
      showSnackbar("Error uploading files. Please try again.", "error");
    } finally {
      setUploading(false);
    }
  };

  // Handle file removal
  // const handleFileRemove = (index) => {
  //   setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
  //   showSnackbar("File removed", "info");
  // };

 const handleFileRemove = async (index) => {
  try {
    const file = uploadedFiles[index];
    if (file.isExisting) {
      const response =
        await commonAPIService.deleteWitnessFile({
          id: file.id,
          appId,
          assessmentId,
          assessorId,
        });
       if (!response.success) {
        showSnackbar("Failed to remove file", "error");
        return;
      }
     }
     setUploadedFiles((prev) =>
      prev.filter((_, i) => i !== index)
    );
    showSnackbar("File removed successfully", "success");
  } catch (error) {
    console.error(error);
    showSnackbar("Error removing file", "error");
  }
};

  // Handle file preview
  const handleFilePreview = async (file) => {
    let fileUrl = file.url;

    // If it's just a filename, get signed URL from S3
    if (s3Utils.isJustFilename(file.url)) {
      try {
        fileUrl = await s3Utils.generateSignedUrlForFilename(file.url);
      } catch (error) {
        console.error("Error generating signed URL:", error);
        showSnackbar("Error loading file preview", "error");
        return;
      }
    }

    setPreviewFile({ ...file, url: fileUrl });
    setPreviewOpen(true);
  };

  // Function to save NC statements to API
  const saveNCStatements = async () => {
    try {
      // First, delete existing NC statements for this scope (if any exist)
      // This ensures we always have the latest selection
      const deleteUrl = `${process.env.REACT_APP_API_URL}/assessment/nc-clause-statement?assessorId=${assessorId}&assessmentId=${assessmentId}&appId=${appId}&orgId=${orgId}&sourceId=${selectedScope?.id}&section=Scope`;

      try {
        await axios.delete(deleteUrl);
        console.log("Existing NC statements cleared");
      } catch (deleteError) {
        console.log(
          "No existing NC statements to delete or delete failed:",
          deleteError.message
        );
        // Continue with insert even if delete fails (might not have existing records)
      }

      // Now save the new NC statements (if any selected)
      if (selectedNCStatements.length === 0) {
        return; // No NC statements to save
      }

      const savePromises = selectedNCStatements.map(async (statement) => {
        const payload = {
          assessorId: assessorId,
          assessmentId: assessmentId,
          appId: appId,
          orgId: orgId,
          sourceId: selectedScope?.id || 0,
          nc_Clause: statement.displayName,
          nc_statement: statement.name,
          section: "Scope Witness",
          insertedBy: localStorage.getItem("orgId") || "0",
        };

        return axios.post(
          `${process.env.REACT_APP_API_URL}/assessment/nc-clause-statement`,
          payload
        );
      });

      await Promise.all(savePromises);
      console.log("NC statements saved successfully");
    } catch (error) {
      console.error("Error saving NC statements:", error);
      throw error; // Re-throw to handle in handleFormSave
    }
  };

  const handleClosePreview = () => {
    setPreviewOpen(false);
    setPreviewFile(null);
  };

  const handleFormSave = async () => {    
    if (!formData.sampleId.trim()) {
      showSnackbar("Please enter Calibration Points Taken", "error");
      return;
    }
    if (!formData.specifiedValue.trim()) {
        showSnackbar("Please enter CMC", "error");
        return;
    }
  
    if (type === "assessor") {
      if (formData.conclusion === "incompetent") {
        if (selectedNCStatements.length === 0) {
          showSnackbar("Please select at least one NC Statement", "error");
          return;
        }
      }
    }

    try {
      const payload = [
        {
          Appid: appId,
          Orgid: orgId,
          Scopeid: selectedScope?.id,
          Assessmentid: assessmentId,
          Assessorid: assessorId,
          FreshSampleId: formData.sampleId,
          earlierTestdate: earlierDateNA === "NA" ? "NA" : earlierDate,
          earlierTestedBy: formData.earlierTestedBy,
          earlierReportedResults: formData.earlierResults,
          resultOfTestWitnessed1: formData.witnessedResults,
          resultOfTestWitnessedSamePerson: isTestBySamePerson,
          testConductedByDifferentPerson: formData.otherPersonName,
          refernceMaterial: formData.referenceMaterial,
          specifiedValue: formData.specifiedValue,
          resultOfTestWitnessed2: formData.rmResults,
          deviationObserved: formData.deviations,
          conclusion: formData.conclusion,
          observation: formData.remark,
          Type_witness: typeOfWitness,
          testConductedBy: formData.testConductedBy,
          testingOfRM: testingOfRM,
          docid: "400",
          evidence: uploadedFiles
            .filter((f) => !f.isExisting)
            .map((file) => ({
              imageName: file.name,
            })),
        },
      ];

      console.log("SAVE PAYLOAD 👉", payload);

      const response = await axios.post(
        `${process.env.REACT_APP_DOT_NET_CORE_API_URL}/set_naf3a`,
        payload
      );

      if (response.data[0]?.isstatus) {
        // Always save/update NC statements (this handles both saving and clearing)
        try {
          await saveNCStatements();
          if (
            formData.conclusion === "incompetent" &&
            selectedNCStatements.length > 0
          ) {
            showSnackbar(
              "Form data and NC statements saved successfully!",
              "success"
            );
          } else {
            showSnackbar("Form data saved successfully!", "success");
          }
        } catch (error) {
          console.error("NC statement save error:", error);
          showSnackbar(
            "Form saved but error updating NC statements",
            "warning"
          );
        }
        setOpenForm(false);
        loadScopeData(); // Reload scope data to get updated information
        window.location.reload();
      } else {
        showSnackbar(response.data?.message || "Failed to save data", "error");
      }
    } catch (error) {
      console.error("Error saving form data:", error);
      showSnackbar("Error saving form data. Please try again.", "error");
    }
  };

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  return (
    <>
      <PageTitle title="NABL || Scope Details" />
      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Box
        sx={{
          p: 3,
          backgroundColor: "#f5f7fa",
          minHeight: "100vh",
        }}
      >
        {/* Header Card */}
        <Card
          sx={{
            mb: 3,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <CardContent sx={{ py: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <ScienceIcon sx={{ fontSize: 32, color: "white" }} />
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: "white",
                  letterSpacing: 0.5,
                }}
              >
                Witness Details
              </Typography>
              <Chip
                label={`${scopeList.length} Scopes`}
                sx={{
                  ml: "auto",
                  bgcolor: "rgba(255,255,255,0.2)",
                  color: "white",
                  fontWeight: 600,
                }}
              />
            </Box>
          </CardContent>
        </Card>

        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              py: 8,
            }}
          >
            <CircularProgress size={48} />
          </Box>
        ) : scopeList.length === 0 ? (
          <Card
            sx={{
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                py: 8,
                px: 3,
              }}
            >
              <ScienceIcon sx={{ fontSize: 64, color: "#ccc", mb: 2 }} />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: "text.secondary",
                  mb: 1,
                }}
              >
                No Scope Data Available
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  textAlign: "center",
                }}
              >
                There are no scope witness details available for this
                assessment.
              </Typography>
            </Box>
          </Card>
        ) : (
          <Card
            sx={{
              boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow
                    sx={{
                      background:
                        "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    }}
                  >
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                      }}
                    >
                      S.No
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                      }}
                    >
                      Test Code
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                      }}
                    >
                      {labType === "1" || labType === "2"
                        ? "Discipline/Group"
                        : "Discipline"}
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                      }}
                    >
                      Product / Material
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                      }}
                    >
                      Specific Test
                    </TableCell>
                    {/* <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                      }}
                    >
                      Test Method
                    </TableCell> */}
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                      }}
                    >
                      Range Details
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                      }}
                    >
                      Proposed check Points
                    </TableCell>
                    <TableCell
                      sx={{
                        color: "#fff",
                        fontWeight: 700,
                        fontSize: "0.875rem",
                        textAlign: "center",
                      }}
                    >
                      Action
                    </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {scopeList.map((scope, index) => (
                    <TableRow
                      key={scope.id}
                      hover
                      sx={{
                        "&:hover": {
                          backgroundColor: "#f8f9fa",
                        },
                      }}
                    >
                      <TableCell sx={{ fontWeight: 600 }}>
                        {index + 1}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.875rem" }}>
                        {scope.testCode || "N/A"}
                      </TableCell>
                      <TableCell>
                        <Typography variant="body2">
                          {scope.disName || "N/A"}
                        </Typography>

                        {(labType === "1" || labType === "2") &&
                          scope.grpName && (
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {scope.grpName}
                            </Typography>
                          )}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.875rem" }}>
                        {scope.productmaterials || "N/A"}
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.875rem" }}>
                        {scope.specifictest || "N/A"}
                      </TableCell>
                      {/* <TableCell sx={{ fontSize: "0.875rem" }}>
                        {scope.testmethod || "N/A"}
                      </TableCell> */}
                      <TableCell sx={{ fontSize: "0.875rem" }}>
                        <Box
                          sx={{
                            display: "grid",
                            gap: 1,
                            gridTemplateColumns: "1fr 1fr",
                          }}
                        >
                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Range
                            </Typography>
                            <Typography variant="body2">
                              {scope?.rangeLL || "-"} {scope?.rangeLLUnit || ""}{" "}
                              to {scope?.rangeUL || "-"}{" "}
                              {scope?.rangeULUnit || ""}
                            </Typography>
                          </Box>

                          <Box>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              CMC
                            </Typography>
                            <Typography variant="body2">
                              {scope?.cv || "-"} {scope?.mu || ""} to{" "}
                              {scope?.cmcuppervalue || "-"}{" "}
                              {scope?.cmcupperUnit || ""}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell sx={{ fontSize: "0.875rem" }}>
                        <TextField
                          fullWidth
                          size="small"
                          type="text"
                          value={scope.checkPoints || ""}
                          onChange={(e) =>
                            handleCheckPointsChange(
                              index,
                              "checkPoints",
                              e.target.value,
                            )
                          }
                        />
                        <Button
                          variant="contained"
                          size="small"
                          sx={{ mt: 1 }}
                          onClick={() => handleSaveCheckPoints(scope)}
                        >
                          {scope.naF3A?.[0]?.type_witness ? 'Update' : 'Save'}
                        </Button>
                      </TableCell>
                      <TableCell sx={{ textAlign: "center" }}>
                        <Tooltip title="Test Witness" arrow>
                          <Button
                            size="small"
                            variant="contained"
                            startIcon={<ArticleIcon />}
                            onClick={() => handleOpenForm(scope)}
                            sx={{
                              background:
                                (scope != null &&
                                  scope.naF3A.length > 0 &&
                                  scope.naF3A[0].conclusion) === "incompetent"
                                  ? "linear-gradient(135deg, #ff4b4b 0%, #b22222 100%)" // 🔴 Red
                                  : (scope != null &&
                                        scope.naF3A.length > 0 &&
                                        scope.naF3A[0].conclusion) ===
                                      "competent"
                                    ? "linear-gradient(135deg, #4CAF50 0%, #087f23 100%)" // 🟢 Green
                                    : "linear-gradient(135deg, #667eea 0%, #764ba2 100%)", // Default

                              textTransform: "none",
                              fontWeight: 600,
                              boxShadow: "0 2px 8px rgba(102,126,234,0.3)",

                              "&:hover": {
                                background:
                                  (scope != null &&
                                    scope.naF3A.length > 0 &&
                                    scope.naF3A[0].conclusion) === "incompetent"
                                    ? "linear-gradient(135deg, #e63939 0%, #8b0000 100%)"
                                    : (scope != null &&
                                          scope.naF3A.length > 0 &&
                                          scope.naF3A[0].conclusion) ===
                                        "competent"
                                      ? "linear-gradient(135deg, #43a047 0%, #056f00 100%)"
                                      : "linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)",

                                boxShadow: "0 4px 12px rgba(102,126,234,0.4)",
                              },
                            }}
                          >
                            Test Witness
                          </Button>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>
        )}

        {/* 🔹 RETESTING FORM DIALOG */}
        <Dialog
          open={openForm}
          fullWidth
          maxWidth="md"
          onClose={() => setOpenForm(false)}
          PaperProps={{
            sx: {
              borderRadius: 2,
              boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
            },
          }}
        >
          <DialogTitle
            sx={{
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <ScienceIcon />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                Test Witness
              </Typography>
            </Box>
            <IconButton
              onClick={() => setOpenForm(false)}
              sx={{
                color: "white",
                "&:hover": { bgcolor: "rgba(255,255,255,0.1)" },
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 0 }}>
            <Box
              sx={{ width: "100%", display: "flex", flexDirection: "column" }}
            >
              <Box sx={{ p: 3 }}>
                 <Box
                  sx={{
                    mb: 2,
                    p: 2,
                    bgcolor: "background.paper",
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{ mb: 1, fontWeight: 600 }}
                  >
                    Scope Details
                  </Typography>

                  <Box
                    sx={{
                      display: "grid",
                      gap: 1,
                      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                    }}
                  >
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Test Code
                      </Typography>
                      <Typography variant="body2">
                        {selectedScope?.testCode || "-"}
                      </Typography>
                    </Box>

                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Discipline
                      </Typography>
                      <Typography variant="body2">
                        {selectedScope?.disName || "-"}
                      </Typography>
                    </Box>

                    {(labType === "1" || labType === "2") && (
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Group
                        </Typography>
                        <Typography variant="body2">
                          {selectedScope?.grpName || "-"}
                        </Typography>
                      </Box>
                    )}

                    <Box sx={{ gridColumn: "1 / -1" }}>
                      <Typography variant="caption" color="text.secondary">
                        Product / Material
                      </Typography>
                      <Typography variant="body2">
                        {selectedScope?.productmaterials || "-"}
                      </Typography>
                    </Box>

                    <Box sx={{ gridColumn: "1 / -1" }}>
                      <Typography variant="caption" color="text.secondary">
                        Specific Test
                      </Typography>
                      <Typography variant="body2">
                        {selectedScope?.specifictest || "-"}
                      </Typography>
                    </Box>

                    {/* <Box sx={{ gridColumn: "1 / -1" }}>
                      <Typography variant="caption" color="text.secondary">
                        Test Method
                      </Typography>
                      <Typography variant="body2">
                        {selectedScope?.testmethod || "-"}
                      </Typography>
                    </Box> */}
                  </Box>
                </Box>
                <Box
                  sx={{
                    mb: 2,
                    p: 2,
                    bgcolor: "background.paper",
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{ mb: 1, fontWeight: 600 }}
                  >
                    Calibration Range Details
                  </Typography>
                  <Box
                    sx={{
                      display: "grid",
                      gap: 1,
                      gridTemplateColumns: "1fr 1fr",
                    }}
                  >
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        Range
                      </Typography>
                      <Typography variant="body2">
                        {selectedScope?.rangeLL || "-"}{" "}
                        {selectedScope?.rangeLLUnit || ""} to{" "}
                        {selectedScope?.rangeUL || "-"}{" "}
                        {selectedScope?.rangeULUnit || ""}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography variant="caption" color="text.secondary">
                        CMC
                      </Typography>
                      <Typography variant="body2">
                        {selectedScope?.cv || "-"} {selectedScope?.mu || ""} to{" "}
                        {selectedScope?.cmcuppervalue || "-"}{" "}
                        {selectedScope?.cmcupperUnit || ""}
                      </Typography>
                    </Box>
                    {selectedScope?.capabilityMode && (
                      <Box>
                        <Typography variant="caption" color="text.secondary">
                          Capability Mode
                        </Typography>
                        <Typography variant="body2">
                          {selectedScope?.capabilityMode || "-"}
                        </Typography>
                      </Box>
                    )}
                    {selectedScope?.rangeRemark ? (
                      <Box sx={{ gridColumn: "1 / -1" }}>
                        <Typography variant="caption" color="text.secondary">
                          Remark
                        </Typography>
                        <Typography variant="body2">
                          {selectedScope?.rangeRemark}
                        </Typography>
                      </Box>
                    ) : null}
                  </Box>
                </Box>
                  <Box
                  sx={{
                    mb: 2,
                    p: 2,
                    bgcolor: "background.paper",
                    border: "1px solid",
                    borderColor: "divider",
                    borderRadius: 2,
                  }}
                >
                  <Typography
                    variant="subtitle2"
                    sx={{ mb: 1, fontWeight: 600 }}
                  >
                    Proposed Check Points
                  </Typography>

                  <Box
                    sx={{
                      display: "grid",
                      gap: 1,
                      gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                    }}
                  >
                    <Box>
                      <Typography variant="body2">
                        {typeOfWitness || "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1, mt: 1, fontWeight: 500 }}
                  >
                    Calibration Points Taken
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    value={formData.sampleId}
                    onChange={(e) => handleChange("sampleId", e.target.value)}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                      },
                    }}
                  />
                </Box>
                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1, mt: 1, fontWeight: 500 }}
                  >
                    CMC
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    value={formData.specifiedValue}
                    onChange={(e) =>
                      handleChange("specifiedValue", e.target.value)
                    }
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                      },
                    }}
                  />
                </Box>

                <Box>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ mb: 1, mt: 1, fontWeight: 500 }}
                  >
                    Remark
                  </Typography>
                  <TextField
                    size="small"
                    fullWidth
                    multiline
                    rows={2}
                    value={formData.remark}
                    onChange={(e) => handleChange("remark", e.target.value)}
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: 1.5,
                      },
                    }}
                  />
                </Box>

                {/* File Upload Section*/}
                <Box sx={{ mt: 2 }}>
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={
                      uploading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <CloudUploadIcon />
                      )
                    }
                    disabled={uploading}
                    sx={{ mb: 2 }}
                  >
                    {uploading ? "Uploading..." : "Upload Evidence Files"}
                    <input
                      type="file"
                      hidden
                      multiple
                      accept="image/*,.pdf,.doc,.docx"
                      onChange={handleFileUpload}
                    />
                  </Button>

                  {uploadedFiles.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography
                        variant="caption"
                        color="text.secondary"
                        sx={{ mb: 1, display: "block" }}
                      >
                        Uploaded Files ({uploadedFiles.length})
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
                        {uploadedFiles.map((file, index) => (
                          <Card
                            key={index}
                            sx={{
                              width: 120,
                              cursor: "pointer",
                              position: "relative",
                              border: file.isExisting
                                ? "1px solid #e0e0e0"
                                : "2px solid #1976d2",
                              "&:hover": {
                                boxShadow: 3,
                                transform: "scale(1.02)",
                              },
                              transition: "all 0.2s",
                            }}
                            onClick={() => handleFilePreview(file)}
                          >
                            <Box
                              sx={{
                                height: 100,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                bgcolor: "grey.100",
                                position: "relative",
                              }}
                            >
                              {file.name.match(/\.(jpg|jpeg|png|gif|bmp)$/i) ? (
                                <ImageIcon
                                  sx={{
                                    fontSize: 40,
                                    color: "primary.main",
                                  }}
                                />
                              ) : (
                                <ArticleIcon
                                  sx={{
                                    fontSize: 40,
                                    color: "primary.main",
                                  }}
                                />
                              )}
                              {file.isExisting && (
                                <Chip
                                  label="Saved"
                                  size="small"
                                  color="default"
                                  sx={{
                                    position: "absolute",
                                    top: 4,
                                    right: 4,
                                    height: 20,
                                    fontSize: "0.65rem",
                                  }}
                                />
                              )}
                            </Box>
                            <Box sx={{ p: 1, bgcolor: "background.paper" }}>
                              <Typography
                                variant="caption"
                                sx={{
                                  display: "block",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  fontSize: "0.7rem",
                                }}
                              >
                                {file.name}
                              </Typography>
                            </Box>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleFileRemove(index);
                              }}
                              sx={{
                                position: "absolute",
                                top: 4,
                                left: 4,
                                bgcolor: "rgba(255,255,255,0.9)",
                                "&:hover": {
                                  bgcolor: "error.main",
                                  color: "white",
                                },
                              }}
                            >
                              <DeleteIcon fontSize="small" />
                            </IconButton>
                          </Card>
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>
                {/* SECTION 3 */}
                {type === "assessor" && (
                  <Stack spacing={2.5} sx={{ pt: 3 }}>
                    <Typography
                      variant="subtitle1"
                      fontWeight={600}
                      color="primary"
                    >
                      Remarks & Conclusion
                    </Typography>

                    <Box>
                      <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 1, fontWeight: 500 }}
                      >
                        Conclusion on the technical competence of the lab for
                        the test witnessed
                      </Typography>
                      <RadioGroup
                        row
                        value={formData.conclusion}
                        onChange={(e) =>
                          handleChange("conclusion", e.target.value)
                        }
                      >
                        <FormControlLabel
                          value="competent"
                          control={<Radio />}
                          label="Competent"
                        />
                        <FormControlLabel
                          value="incompetent"
                          control={<Radio />}
                          label="Incompetent"
                        />
                      </RadioGroup>
                    </Box>
                    {formData.conclusion === "incompetent" && (
                      <>
                        <Box>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{ mb: 1, fontWeight: 500 }}
                          >
                            NC Statements *
                          </Typography>
                          <Autocomplete
                            multiple
                            size="small"
                            options={scrutinyRemarks}
                            disableCloseOnSelect
                            loading={loadingRemarks}
                            getOptionLabel={(option) =>
                              `${option.displayName} - ${option.name}`
                            }
                            isOptionEqualToValue={(option, value) =>
                              option.displayName === value.displayName &&
                              option.name === value.name
                            }
                            value={selectedNCStatements}
                            onChange={(event, newValue) => {
                              setSelectedNCStatements(newValue);
                            }}
                            renderOption={(props, option, { selected }) => (
                              <li {...props}>
                                <Checkbox
                                  icon={
                                    <CheckBoxOutlineBlankIcon fontSize="small" />
                                  }
                                  checkedIcon={
                                    <CheckBoxIcon fontSize="small" />
                                  }
                                  style={{ marginRight: 8 }}
                                  checked={selected}
                                />
                                <Box>
                                  <Typography variant="body2" fontWeight={600}>
                                    {option.displayName}
                                  </Typography>
                                  <Typography
                                    variant="caption"
                                    color="text.secondary"
                                  >
                                    {option.name}
                                  </Typography>
                                </Box>
                              </li>
                            )}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                placeholder="Select NC Statements"
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    borderRadius: 1.5,
                                  },
                                }}
                              />
                            )}
                            renderTags={(value, getTagProps) =>
                              value.map((option, index) => (
                                <Chip
                                  label={option.displayName}
                                  size="small"
                                  {...getTagProps({ index })}
                                  sx={{ borderRadius: 1 }}
                                />
                              ))
                            }
                          />
                          {selectedNCStatements.length > 0 && (
                            <Box
                              sx={{
                                mt: 1.5,
                                p: 1.5,
                                bgcolor: "primary.50",
                                borderRadius: 1,
                                border: "1px solid",
                                borderColor: "primary.200",
                              }}
                            >
                              <Typography
                                variant="caption"
                                fontWeight={600}
                                color="primary.main"
                                sx={{ display: "block", mb: 0.5 }}
                              >
                                {selectedNCStatements.length} NC Statement(s)
                                Selected:
                              </Typography>
                              {selectedNCStatements.map((statement, index) => (
                                <Typography
                                  key={index}
                                  variant="caption"
                                  color="text.secondary"
                                  sx={{ display: "block", ml: 1, mt: 0.5 }}
                                >
                                  • {statement.displayName} - {statement.name}
                                </Typography>
                              ))}
                            </Box>
                          )}
                        </Box>
                      </>
                    )}
                  </Stack>
                )}
              </Box>

              {/* Action Buttons */}
              <Box
                sx={{
                  position: "sticky",
                  bottom: 0,
                  zIndex: 10,
                  bgcolor: "#f8f9fa",
                  borderTop: "1px solid #e0e0e0",
                  px: 3,
                  py: 2,
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                }}
              >
                <Button
                  variant="outlined"
                  color="error"
                  onClick={handleClose}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    px: 3,
                    borderRadius: 1.5,
                  }}
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  onClick={handleFormSave}
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    px: 3,
                    borderRadius: 1.5,
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #5568d3 0%, #6a3f8f 100%)",
                    },
                  }}
                >
                  Save
                </Button>
              </Box>
            </Box>
          </DialogContent>
        </Dialog>

        {/* File Preview Dialog */}
        <Dialog
          open={previewOpen}
          onClose={handleClosePreview}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              bgcolor: "primary.main",
              color: "white",
            }}
          >
            <Typography variant="h6">File Preview</Typography>
            <IconButton onClick={handleClosePreview} sx={{ color: "white" }}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent sx={{ p: 3, minHeight: 400 }}>
            {previewFile && (
              <Box>
                <Typography variant="subtitle2" gutterBottom>
                  {previewFile.name}
                </Typography>
                <Box
                  sx={{
                    mt: 2,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: 300,
                  }}
                >
                  {previewFile.name.match(/\.(jpg|jpeg|png|gif|bmp)$/i) ? (
                    <img
                      src={previewFile.url}
                      alt={previewFile.name}
                      style={{
                        maxWidth: "100%",
                        maxHeight: "500px",
                        objectFit: "contain",
                      }}
                      onError={(e) => {
                        e.target.src =
                          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect fill='%23f0f0f0' width='200' height='200'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' fill='%23999' font-size='16'%3EImage not available%3C/text%3E%3C/svg%3E";
                      }}
                    />
                  ) : previewFile.name.match(/\.(pdf)$/i) ? (
                    <iframe
                      src={previewFile.url}
                      style={{
                        width: "100%",
                        height: "500px",
                        border: "1px solid #e0e0e0",
                      }}
                      title={previewFile.name}
                    />
                  ) : (
                    <Box sx={{ textAlign: "center", py: 4 }}>
                      <ArticleIcon
                        sx={{ fontSize: 80, color: "grey.400", mb: 2 }}
                      />
                      <Typography variant="body1" color="text.secondary">
                        Preview not available for this file type
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{ mt: 2 }}
                        onClick={() => window.open(previewFile.url, "_blank")}
                      >
                        Download File
                      </Button>
                    </Box>
                  )}
                </Box>
              </Box>
            )}
          </DialogContent>
        </Dialog>

        {/* Location Warning Dialog */}
        <LocationWarningDialog
          open={locationWarningOpen}
          onClose={() => setLocationWarningOpen(false)}
          distanceMessage={distanceMessage}
        />

        {/* Hourly Attendance Dialog */}
        <HourlyAttendanceDialog
          open={attendanceCheckDialogOpen}
          onClose={() => setAttendanceCheckDialogOpen(false)}
          message={attendanceCheckMessage}
          onRecheck={checkHourlyAttendance}
        />
      </Box>
    </>
  );
}
